export default {
    resourceLabel:"Ressources",
    resourceLabelAlt:"Ressource",
    resourceDescription:"Accédez à des supports d'apprentissage complets pour vos études de langues",
    searchResourcePlaceholder:"Rechercher des ressources",
    recentResourcesLabel:"Ressources récentes",
    recentlyViewedResourcesLabel:"Récemment consultées",
    loadResourceActionButtonLabel:"Charger la ressource",

    resourceLibraryTitle:"Bibliothèque de ressources",
    resourceLibraryDescription:"Explorez des supports d'apprentissage complets",
    backToResourcesActionButtonLabel:"Retour aux ressources",
    resourceReviewCountLabel:"({{reviewCount}} avis)",
}
